// 模块权限 key -> 标签 + 路由（一级类目授权；与后端 server/src/common/modules.ts 的 MODULE_PREFIX 保持一致）
// 账套/首页/用户管理不受权限控制；二级/三级页签共用父路径前缀，授权一级后自动全部可用。
export const MODULE_KEYS: Record<string, { label: string; path: string }> = {
  vouchers: { label: '凭证管理', path: '/vouchers' },
  ledger: { label: '账簿查询', path: '/ledger' },
  statements: { label: '财务报表', path: '/financial-statements' },
  period: { label: '结账', path: '/period-close' },
  fixed: { label: '固定资产', path: '/fixed-assets' },
  invoices: { label: '发票管理', path: '/invoices' },
  settings: { label: '设置', path: '/settings' },
  expenses: { label: '费用单据', path: '/expenses' },
  tax: { label: '税务申报', path: '/tax-declaration' },
  payroll: { label: '工资管理', path: '/payroll' },
  taxcalc: { label: '个税计算', path: '/tax-calculator' },
  bank: { label: '银行对账', path: '/bank' },
  shortlinks: { label: '短链管理', path: '/short-links' },
  statement: { label: '流水生成', path: '/statement' },
  inventory: { label: '进销存', path: '/inventory' },
  receivables: { label: '应收应付', path: '/receivables-payables' },
  cert: { label: '证照管理', path: '/certificates' },
};

export const ALL_MODULE_KEYS = Object.keys(MODULE_KEYS);

// 核心 7 项（账套内），新员工默认开放
export const CORE_MODULE_KEYS = ['vouchers', 'ledger', 'statements', 'period', 'fixed', 'invoices', 'settings'];

// 员工是否有权访问某模块：permissions 为 null/undefined 视为不限制；否则需包含该 key
export function hasModule(permissions: string[] | null | undefined, key: string): boolean {
  if (!Array.isArray(permissions)) return true;
  return permissions.includes(key);
}
